module.exports = __webpack_public_path__ + "media/images/sp/costumes/mv_shiromuku@3x-53043dba1a4f138cf1015298bf9ca2b1.webp";